import React, {useEffect, useState} from "react";
import Input from "../Common/Input";
import Button from "../Common/Button";
import IMG from "../../constants/image";
import {ERROR_MESSAGE, LOCAL_STORAGE_KEY, PATH, VARIANT} from "../../constants";
import './style.css';
import {merchantRegisterInputPwd, resetPassword} from "../../network/api";
import authStore from "../../store/authStore";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";


const StepCreatePassword = ({setStep, forgot}) => {
	const navigate = useNavigate();
	const {confirmId, phoneNumber} = authStore() || {};
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [error, setError] = useState('');
	
	useEffect(() => {
		setError('');
	}, [password, confirmPassword]);
	
	
	const checkPasswordMatch = () => {
		return password === confirmPassword;
	};
	
	const handleSubmit = async (e) => {
		
		if (password.length < 6 || confirmPassword.length < 6) {
			setError('Mật khẩu phải có ít nhất 6 ký tự');
		} else if (!checkPasswordMatch()) {
			setError('Mật khẩu không trùng khớp');
		} else {
			if(forgot){
				const resetData = await resetPassword({confirmId, password});
				if (resetData?.success) {
					navigate(PATH.HOME)
					window.localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN, resetData?.data?.data?.accessToken || '')
					window.localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, resetData?.data?.data?.refreshToken || '')
				}
			}else {
				const res = await merchantRegisterInputPwd({confirmId, password});
				if (res?.success) {
					setStep(4)
					window.localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN, res?.data?.data?.accessToken || '')
					window.localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, res?.data?.data?.refreshToken || '')
				}
			}
		}
	};
	
	
	return (
		<div
			className='w-[320px] md:w-[400px] py-[15px] px-[20px] md:px-[50px] md:py-[15px] text-xs bg-white rounded-2xl z-[1]'>
			<form className='flex flex-col justify-center items-center text-center gap-5' action="">
				<h2 className='text-sm font-bold'>Tạo mật khẩu</h2>
				<p
					className='text-xs text-[#9E9E9E]'>{`Số điện thoại ${phoneNumber} chưa có tài khoản tại FuNong.vn. Vui lòng tạo mật khẩu để đăng ký tài khoản`}</p>
				<Input
					type='password'
					autoComplete="new-password"
					className='w-full h-[44px]'
					icon={IMG.icon.lockedBlack}
					iconR={IMG.icon.eyeBlack}
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					placeholder='Tạo mật khẩu'/>
				<Input
					type='password'
					className='w-full h-[44px]'
					autoComplete="new-password"
					icon={IMG.icon.lockedBlack}
					iconR={IMG.icon.eyeBlack}
					value={confirmPassword}
					onChange={(e) => setConfirmPassword(e.target.value)}
					error={error}
					placeholder='Nhập lại mật khẩu mới'/>
				
				<Button
					disabled={!password || !confirmPassword}
					variant={VARIANT.PRIMARY} className='w-full h-[44px]'
					type='submit' onClick={handleSubmit}
				>
					Tiếp tục
				</Button>
			</form>
		</div>
	);
}

export default StepCreatePassword;
